import React, { Component } from 'react';
import { List } from 'semantic-ui-react';

import { defaultDateFormat } from 'Common/GeneralHelper';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';

class EffectiveDate extends Component {
  onClick = () => {
    this.props.onClick(this.props.student);
  };

  render() {
    const { student } = this.props;

    return (
      <List.Item
        as={'a'}
        className={'manage-application--effective-date'}
        onClick={this.onClick}
      >
        <List.Content>
          {defaultDateFormat(student[Fields.EffectiveDate])}
        </List.Content>
      </List.Item>
    );
  }
}

export { EffectiveDate };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/EffectiveDate.js